var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfiguration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 13.3636V10.6364L19.0473 10.2336C18.8736 9.54065 18.5979 8.87733 18.2291 8.26545L20.0327 5.89273L18.1073 3.96455L15.7345 5.76818C15.1227 5.3994 14.4594 5.12366 13.7664 4.95L13.3636 2H10.6364L10.2336 4.95273C9.54065 5.12639 8.87733 5.40213 8.26545 5.77091L5.89273 3.96455L3.96455 5.89273L5.76818 8.26545C5.3994 8.87733 5.12366 9.54065 4.95 10.2336L2 10.6364V13.3636L4.95273 13.7664C5.12639 14.4594 5.40213 15.1227 5.77091 15.7345L3.96727 18.1073L5.89545 20.0355L8.26818 18.2318C8.88006 18.6006 9.54337 18.8763 10.2364 19.05L10.6364 22H13.3636L13.7664 19.0473C14.4594 18.8736 15.1227 18.5979 15.7345 18.2291L18.1073 20.0327L20.0355 18.1045L18.2318 15.7318C18.6006 15.1199 18.8763 14.4566 19.05 13.7636L22 13.3636Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.7273C13.5062 14.7273 14.7273 13.5062 14.7273 12C14.7273 10.4937 13.5062 9.27271 12 9.27271C10.4937 9.27271 9.27271 10.4937 9.27271 12C9.27271 13.5062 10.4937 14.7273 12 14.7273Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfiguration);
export default __webpack_public_path__ + "static/media/configuration.bdc5dba6efe5c2cd28c51fb120decdb2.svg";
export { ForwardRef as ReactComponent };